function About(props)
{
    return(
      <div className="about-page">
        <div id="name">
          <div id="body-name">
            Mi Young Kim
          </div>
          <div id="body-subtitle">
            Digital Minhwa Artist
          </div>
        </div>
        <div id="gap"/>
        <div id="intro">
          <div id="about" className="ab">
            <div id="body-title">
              About
            </div>
            <div id="body-text">
  After earning my graduate degree, I spent about 10 years working as a designer and university lecturer, specializing in spatial design and color design. When I moved to the United States, my career took a brief pause, during which my fascination with traditional Korean folk painting, Minhwa, grew significantly.
            </div>
            <div id="body-text">
  My artistic journey began with a desire to reinterpret Minhwa through a contemporary lens. Using digital graphic tools, I seek to modernize and reimagine these traditional works in fresh, innovative ways. Through my art, I aim to create a bridge between the past and present, exploring the symbolic meanings of Minhwa while presenting them in a modern context. I hope my work inspires others to engage with tradition in a new and vibrant way.
            </div>
          </div>
          <div id="education" className="ab">
            <div id="body-title">
              Education
            </div>
            <dl id="body-text">
              <dt>Ewha Womans University, Seoul, South Korea </dt>
              <dt>Master of Fine Arts in Interior & Environmental Design, 2001</dt>
              <dt> Graduate School, College of Arts and Design </dt>
            </dl>
            <dl id="body-text">
              <dt>Ewha Womans University, Seoul, South Korea</dt>
              <dt>Bachelor of Fine Arts in Interior & Environmental Design, 1999</dt>
              <dt>College of Arts and Design</dt>
            </dl>
          </div>
          <div id="experience" className="ab">
            <div id="body-title">
              Experience
            </div>
            <div>
              <ul id="body-text">
                <dt id="exp-subtitle">
                  Exhibition
                </dt>
                <li>
                The Inaugural Art Exhibition - Ewha Womans Univ. San Francisco Nokmee (Feb-Apr 2025)
                </li>
              </ul>
              <ul id="body-text">
                <dt id="exp-subtitle">
  Professional Experience
                </dt>
                <li>
  Ewha Womans University (2003-2010) - Team Leader, Color Design Research Institute
                </li>
                <li>
  Somssi Environmental Design Research Institute (2003) - Environmental Design
                </li>
                <li>
  Ridge P&C Co., Ltd. (2001-2003) - Design (Residential)
                </li>
              </ul>
              <ul id="body-text">
                <dt id="exp-subtitle">
                  Teaching Experience
                </dt>
                <li>
                  Ewha Womans University (2005-2011) - Lecturer, Design & Color Design Graduate School
                </li>
                <li>
                  Hanyang University (2007) - Lecturer, Space and Color
                </li>
                <li>
                  Kyung Hee University (2006) - Lecturer
                </li>
                <li>
                  Dongduk Women's University (2005-2006) - Lecturer, Color Studies
                </li>
                <li>
                  Gimcheon University (2004) - Lecturer, Color Theory
                </li>
                <li>
                  Hanbat University (2003) - Lecturer, Color Theory
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
}
export default About;
